import { render, staticRenderFns } from "./ifp-filter-last-updated-within-days.vue?vue&type=template&id=4632a536&"
import script from "./ifp-filter-last-updated-within-days.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-last-updated-within-days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports